
import { getApiVersion } from './config.js'
import { makeGetRequest, makePostRequest } from './util.js'

function getStudentSchedule(studentId, scheduleType, queryParams) {
  var filteredQueryParams = {}
  if (queryParams?.date) filteredQueryParams.date = queryParams.date
  if (queryParams?.studentInfoId) filteredQueryParams.si_id = queryParams.studentInfoId
  if (queryParams?.futureScheduleId) filteredQueryParams.fs_id = queryParams.futureScheduleId
  if (queryParams?.scheduleRequestId) filteredQueryParams.sr_id = queryParams.scheduleRequestId
  return makeGetRequest(`${getApiVersion()}/schedule/${studentId}/${scheduleType}`, filteredQueryParams)
}

function getStudentScheduleDiff(studentId, queryParams) {
  var filteredQueryParams = {}
  if (queryParams?.type) filteredQueryParams.type = queryParams.type
  if (queryParams?.typeId) filteredQueryParams.type_id = queryParams.typeId
  if (queryParams?.againstType) filteredQueryParams.against_type = queryParams.againstType
  if (queryParams?.againstTypeId) filteredQueryParams.against_type_id = queryParams.againstTypeId
  return makeGetRequest(`${getApiVersion()}/schedule_diff/${studentId}`, filteredQueryParams)
}

function postFutureSchedulePull(studentId, body) {
  return makePostRequest(`${getApiVersion()}/future_schedule_pull/${studentId}`, body)
}

function getFutureSchedulePull(studentId, queryParams) {
  var filteredQueryParams = {}
  if (queryParams?.scheduleRequestId) filteredQueryParams.sr_id = queryParams.scheduleRequestId
  return makeGetRequest(`${getApiVersion()}/future_schedule_pull/${studentId}`, filteredQueryParams)
}


export {
  getStudentSchedule,
  getStudentScheduleDiff,
  postFutureSchedulePull,
  getFutureSchedulePull,
}
